module.exports = __webpack_public_path__ + "img/gesture_guidance_2_card_image.ac0bd305.jpg";